'use client'
import ChevronDown from '@/components/icons/chevron-down'
import { useState } from 'react'

export default function LiveryDropdowns({ searchParams }) {
  const [dropdown1, setDropdown1] = useState(false)
  const [dropdown2, setDropdown2] = useState(false)
  const [dropdown3, setDropdown3] = useState(false)
  const [dropdown4, setDropdown4] = useState(false)
  return (
    <div className="mx-auto mt-[71px] flex w-full flex-col font-inter lg:max-w-5xl desktop-xs:mt-[100px]">
      <div className="text-[30px]">
        Why choose Grid Finder for your sim racing livery designs?
      </div>
      <div className="divider mx-auto flex h-4 w-full items-center"></div>

      <div className="flex w-full">
        <div className="flex w-[95%] flex-col">
          <div
            className="w-full cursor-pointer text-[23px] font-semibold"
            onClick={() => setDropdown1(!dropdown1)}
          >
            Wide Selection of Talented Designers
          </div>
          <div
            className={
              dropdown1
                ? 'mt-4 block text-neutral-blue-500'
                : 'mt-4 hidden text-neutral-blue-500'
            }
          >
            Grid Finder hosts an array of skilled livery designers, offering a
            diverse range of styles to match your personal or team branding.
          </div>
        </div>
        <div
          className="w-[5%] cursor-pointer"
          onClick={() => setDropdown1(!dropdown1)}
        >
          <ChevronDown
            className={
              dropdown1
                ? 'ml-auto mr-0 w-7 rotate-180 stroke-shades-0 stroke-2 transition-all duration-300 ease-in-out'
                : 'ml-auto mr-0 w-7 rotate-0 stroke-shades-0 stroke-2 transition-all duration-300 ease-in-out'
            }
          />
        </div>
      </div>
      <div className="divider mx-auto flex h-4 w-full items-center"></div>
      <div className="flex w-full">
        <div className="flex w-[95%] flex-col">
          <div
            className="cursor-pointer text-[23px] font-semibold"
            onClick={() => setDropdown2(!dropdown2)}
          >
            Quality and Creativity
          </div>
          <div
            className={
              dropdown2
                ? 'mt-4 block text-neutral-blue-500'
                : 'mt-4 hidden text-neutral-blue-500'
            }
          >
            Each designer on Grid Finder is dedicated to creativity and quality,
            ensuring that you get a design that is unique and professionally
            crafted.
          </div>
        </div>
        <div
          className="w-[5%] cursor-pointer"
          onClick={() => setDropdown2(!dropdown2)}
        >
          <ChevronDown
            className={
              dropdown2
                ? 'ml-auto mr-0 w-7 rotate-180 stroke-shades-0 stroke-2 transition-all duration-300 ease-in-out'
                : 'ml-auto mr-0 w-7 rotate-0 stroke-shades-0 stroke-2 transition-all duration-300 ease-in-out'
            }
          />
        </div>
      </div>
      <div className="divider mx-auto flex h-4 w-full items-center"></div>
      <div className="flex w-full">
        <div className="flex w-[95%] flex-col">
          <div
            className="cursor-pointer text-[23px] font-semibold"
            onClick={() => setDropdown3(!dropdown3)}
          >
            Easy Browsing and Selection
          </div>
          <div
            className={
              dropdown3
                ? 'mt-4 block text-neutral-blue-500'
                : 'mt-4 hidden text-neutral-blue-500'
            }
          >
            The platform's user-friendly interface allows you to effortlessly
            browse and compare different designer's work, making the selection
            process easy.
          </div>
        </div>
        <div
          className="w-[5%] cursor-pointer"
          onClick={() => setDropdown3(!dropdown3)}
        >
          <ChevronDown
            className={
              dropdown3
                ? 'ml-auto mr-0 w-7 rotate-180 stroke-shades-0 stroke-2 transition-all duration-300 ease-in-out'
                : 'ml-auto mr-0 w-7 rotate-0 stroke-shades-0 stroke-2 transition-all duration-300 ease-in-out'
            }
          />
        </div>
      </div>
      <div className="divider mx-auto flex h-4 w-full items-center"></div>
      <div className="flex w-full">
        <div className="flex w-[95%] flex-col">
          <div
            className="cursor-pointer text-[23px] font-semibold"
            onClick={() => setDropdown4(!dropdown4)}
          >
            Tailored for Various Racing Titles
          </div>
          <div
            className={
              dropdown4
                ? 'mt-4 block text-neutral-blue-500'
                : 'mt-4 hidden text-neutral-blue-500'
            }
          >
            With designers specializing in different sim racing titles, you're
            guaranteed to find the perfect match for your specific game, be it
            iRacing, Assetto Corsa Competizione, rFactor 2 or Assetto Corsas.
          </div>
        </div>
        <div
          className="w-[5%] cursor-pointer"
          onClick={() => setDropdown4(!dropdown4)}
        >
          <ChevronDown
            className={
              dropdown4
                ? 'ml-auto mr-0 w-7 rotate-180 stroke-shades-0 stroke-2 transition-all duration-300 ease-in-out'
                : 'ml-auto mr-0 w-7 rotate-0 stroke-shades-0 stroke-2 transition-all duration-300 ease-in-out'
            }
          />
        </div>
      </div>
      <div className="divider mx-auto flex h-4 w-full items-center"></div>
    </div>
  )
}
